import { Circle, useToken } from '@chakra-ui/react';

import { hexToRGBA } from '@/client/utils/hexToRGBA';

interface StatusCircleProps {
  variant: 'success' | 'error' | 'neutral' | 'warmNeutral';
}

export default function StatusCircle({ variant }: StatusCircleProps) {
  const [success, error] = useToken('colors', ['success', 'error']);

  const variantColorMap = {
    success: {
      outer: hexToRGBA(success, 0.2),
      inner: hexToRGBA(success, 1),
    },
    error: {
      outer: hexToRGBA(error, 0.2),
      inner: hexToRGBA(error, 1),
    },
    neutral: {
      outer: 'neutral.200',
      inner: 'neutral.400',
    },
    warmNeutral: {
      outer: 'warmNeutral.200',
      inner: 'warmNeutral.400',
    },
  };

  return (
    <Circle size={4} backgroundColor={variantColorMap[variant].outer}>
      <Circle size={2} backgroundColor={variantColorMap[variant].inner} />
    </Circle>
  );
}
